import { Model, belongsTo, hasMany } from 'miragejs';

import { ModelWithVersion } from './utils';

export default {
  user: Model,
  page: ModelWithVersion.extend({
    parentPage: belongsTo('page', { inverse: null }),
    type: belongsTo('pageType'),
    competition: belongsTo(),
    event: belongsTo(),
  }),
  pageType: Model,
  article: ModelWithVersion.extend({
    event: belongsTo(),
    relatedDisciplines: hasMany('discipline'),
    relatedAthletes: hasMany('athlete'),
    relatedDocuments: hasMany('document'),
    relatedCompetition: hasMany('competition'),
    article: belongsTo('article', { inverse: null }),
    relatedArticles: hasMany('article'),
  }),
  email: ModelWithVersion.extend({
    event: belongsTo(),
  }),
  book: ModelWithVersion,
  competition: Model.extend({
    article: belongsTo(),
  }),
  event: Model.extend({
    article: belongsTo(),
  }),
  athlete: Model.extend({
    article: belongsTo(),
  }),
  discipline: Model.extend({
    article: belongsTo(),
  }),
  document: Model.extend({
    article: belongsTo(),
  }),
};
